import React, {useState, useEffect, type JSXElementConstructor, type ReactElement} from 'react'
import {Snackbar, Alert} from '@mui/material'

interface CpsSnackbarProps {
    vertical?: 'top' | 'bottom'
    horizontal?: 'right' | 'left' | 'center'
    mode?: 'error' | 'success' | 'warning' | 'info'
    msg?: string
    setMsg?(...args: unknown[]): unknown
    deleteInfo?: React.ReactElement
    setDeleteInfo?(...args: unknown[]): unknown
    icon?: any
    onClose?(...args: unknown[]): unknown
    className?: string
    autoHideDuration?: number
}

const CpsSnackbar = ({
    vertical,
    horizontal,
    msg,
    setMsg,
    deleteInfo,
    setDeleteInfo,
    mode,
    icon,
    className,
    autoHideDuration,
    onClose
}: CpsSnackbarProps) => {
    const [open, setOpen] = useState(false)
    const [message, setMessage] =
    useState<ReactElement<unknown, string | JSXElementConstructor<any>> | undefined | string>('')

    const handleClose = () => {
        setOpen(false)
        setMessage('')
        if (setMsg) setMsg('')
        if (setDeleteInfo) setDeleteInfo('')
    }

    const handleOpen = () => {
        setOpen(true)
        setMessage(msg)
    }

    const handleDeleteOpen = () => {
        setOpen(true)
        setMessage(deleteInfo)
    }

    useEffect(() => {
        if (msg && msg?.length > 0) {
            handleOpen()
        } else {
            handleClose()
        }
    }, [msg])

    useEffect(() => {
        if (deleteInfo) {
            handleDeleteOpen()
        }
    }, [deleteInfo])

    return (
        <Snackbar
            anchorOrigin={{vertical: vertical ?? 'top', horizontal: horizontal ?? 'right'}}
            open={open}
            onClose={() => {
                if (onClose) onClose()
                handleClose()
            }}
            key={String(vertical) + String(horizontal)}
            autoHideDuration={autoHideDuration}
            className={className ? `${className}` : ''}
        >
            <Alert
                onClose={() => {
                    if (onClose) onClose()
                    handleClose()
                }}
                variant='filled'
                severity={mode ?? 'error'}
                iconMapping={{
                    success: icon
                }}
                sx={{width: '100%'}}
            >
                {message}
            </Alert>
        </Snackbar>
    )
}

CpsSnackbar.defaultProps = {
    vertical: 'top',
    horizontal: 'right',
    mode: 'error',
    className: '',
    setMsg: () => {},
    setDeleteInfo: () => {},
    icon: null,
    autoHideDuration: 4000,
    onClose: () => {}
}

export default CpsSnackbar
